import { render, staticRenderFns } from "./RomaFile.vue?vue&type=template&id=42d50f6c&scoped=true&"
import script from "./RomaFile.vue?vue&type=script&lang=js&"
export * from "./RomaFile.vue?vue&type=script&lang=js&"
import style0 from "./RomaFile.vue?vue&type=style&index=0&id=42d50f6c&Lang=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d50f6c",
  null
  
)

export default component.exports